import { postRequest } from 'utils/request';

// eslint-disable-next-line import/prefer-default-export
export const createCSVMappings = (body) => postRequest('/csv-mappings/products', body);
